import { Alarm, DaysOfRepeat } from './Organizer';
import { WebUser } from './User';

export enum EventType {
  ALARM,
  BIRTHDAY,
  DATE,
  REMINDER,
  TODO,
}

export enum Recurrence {
  AFTER = 'AFTER',
  ALWAYS = 'ALWAYS',
  NONE = 'NONE',
  UNTIL = 'UNTIL',
}

export type OriginalEvent = {
  id: string;
}

export type Event = {
  id: string;
  alarm: Alarm;
  comments?: string;
  creator: WebUser;
  date: number;
  daysOfRepeat?: DaysOfRepeat;
  done: boolean;
  duration: number;
  endOfRepeatDate?: number;
  ignoreDate: number[];
  isAllDay: boolean;
  name: string;
  occurrence?: number;
  originalEvent?: OriginalEvent;
  recurrence: Recurrence;
  type: EventType;
  untilDate?: number;
};

export type Timeslot = {
  date: number;
  duration: number;
};

export type EventOrTimeslot = Event | Timeslot;

export type EventsAndTimeslots = EventOrTimeslot[];

export const isEvent = (
  eventOrTimeslot: EventOrTimeslot,
): eventOrTimeslot is Event => !!(eventOrTimeslot as Event).id;